<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-visit-point-list" class="page-visit-point-list">
		<vx-card card-border no-shadow>
			<section class="flex justify-between items-center">
				<div class="vx-row">
					<div class="vx-col sm:wfull w-full">
						<span style="font-size: 1em; font-weight: 400">{{ $t("PickupPoints") + " = " }}</span>
						<span class="mr-8 font-bold text-l"
							>{{ totalVisitPointChecked + " /" }}{{ usersData ? " " + usersData.length : " " + 0 }}</span
						>
						<span style="font-size: 1em; font-weight: 400">{{ $t("DeliveryPoints") + " = " }}</span>
						<span class="font-bold text-l"
							>{{ totalVisitPointCheckedDelivery + " /"
							}}{{ usersData ? " " + usersData.length : " " + 0 }}</span
						>
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col sm:wfull w-full">
						<div class="flex justify-between items-center">
							<vs-button
								type="border"
								class="ml-2"
								color="primary"
								icon-pack="feather"
								icon="icon-refresh-cw"
								:title="$t('Refresh')"
								@click.prevent="refreshVisitPoint()"
							></vs-button>
							<vs-button
								v-if="
									getCheckedVisitPointsPickup.length > 0 || getCheckedVisitPointsDelivery.length > 0
								"
								type="border"
								class="ml-2"
								color="primary"
								icon-pack="feather"
								icon="icon-eye"
								:title="$t('VisitPoints.ShowOnlySelectedVisitPoints')"
								@click.prevent="selectedVisitsPoint(1)"
							></vs-button>
							<vs-button
								v-if="customConfig.showMaximizeBtn && maximize"
								class="ml-2"
								color="primary"
								type="border"
								icon-pack="feather"
								:title="$t('Routing.Map.ShowMap')"
								:icon="'icon-map'"
								@click.prevent="handleMaximizeEmit"
							></vs-button>
						</div>
					</div>
				</div>
			</section>
			<div class="vx-row pt-8 flex items-center">
				<div class="vx-col md:w-2/5 sm:w-2/5 w-full p-0">
					<template>
						<vs-dropdown vs-trigger-click class="cursor-pointer w-full">
							<div
								class="p-3 mr-2 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer font-medium"
							>
								<span class="mr-2">{{ $t("SearchBy") }} {{ searchSelected }}</span>
								<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
							</div>
							<vs-dropdown-menu>
								<vs-dropdown-item @click="setSearchField('Identification')">
									<span>{{ $t("ResourceModule.Table.Identification") }}</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="setSearchField('Address')">
									<span>{{ $t("ResourceModule.Table.Address") }}</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="setSearchField('Department')">
									<span>{{ $t("ResourceModule.Table.Department") }}</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="setSearchField('City')">
									<span>{{ $t("ResourceModule.Table.City") }}</span>
								</vs-dropdown-item>
								<vs-dropdown-item @click="setSearchField('AdditionalFields')">
									<span>{{ $t("AdditionalFields") }}</span>
								</vs-dropdown-item>
							</vs-dropdown-menu>
						</vs-dropdown>
					</template>
				</div>
				<div class="vx-col md:w-3/5 sm:w-3/5 w-full p-0" v-if="searchField === 'AdditionalFields'">
					<div class="vx-row">
						<div class="vx-col w-full">
							<v-select
								v-model="additionalField"
								class="w-full"
								multiple
								:clearable="false"
								:options="additionalOptions"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								:placeholder="$t('Select')"
							>
								<template #option="{label, value}">
									{{ label }}
									<br />
									<cite v-if="searchField !== 'label'" style="font-size: 12px">{{ value }}</cite>
								</template>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
									<template v-else>
										{{ $t("NoResultsFound") }}
									</template>
								</template>
							</v-select>
						</div>
					</div>
				</div>
				<div
					v-show="searchField !== 'AdditionalFields'"
					id="search-data"
					class="vx-col md:w-3/5 sm:w-3/5 w-full p-0"
				>
					<vx-tooltip
						class="cursor-pointer"
						color="primary"
						position="bottom"
						delay=".1s"
						:title="$t('Search')"
						:text="$t('SearchSeparatedByCommas') + '.'"
					>
						<tags-input
							inputId="searchdataPickup"
							element-id="tags"
							v-model="searchQuery"
							add-tags-on-comma
							add-tags-on-blur
							:placeholder="$t('Teams.Form.Add') + ' ' + searchSelected"
							:typeahead="true"
							@keyup.enter="searchVisitPoint"
							@input="clearInput"
						></tags-input>
					</vx-tooltip>
				</div>
			</div>
			<div class="vx-row pt-2">
				<div class="vx-col w-full flex justify-end items-center p-0">
					<div v-if="showSelected && getCheckedVisitPointsPickup && getCheckedVisitPointsPickup.length > 0">
						<vs-chip color="success" @click="removeChips" closable>
							<span class="font-bold text-sm">{{ $t("Selected") }}</span>
						</vs-chip>
					</div>
					<vs-button
						v-if="searchQuery.length > 0"
						class="ml-2"
						color="primary"
						icon-pack="feather"
						icon="icon-x-square"
						:title="$t('ResourceModule.Create.Clear') + ' ' + $t('Search')"
						@click.prevent="clearSearch"
						>{{ windowWidth > 620 ? $t("ResourceModule.Create.Clear") : null }}</vs-button
					>
					<vs-button
						class="ml-2"
						color="primary"
						icon-pack="feather"
						icon="icon-search"
						:title="$t('VisitPoints.Search')"
						@click.prevent="searchVisitPoint"
						>{{ windowWidth > 620 ? $t("VisitPoints.Search") : null }}</vs-button
					>
				</div>
			</div>
		</vx-card>
		<!-- AgGrid Table -->
		<ag-grid-vue
			ref="agGridTable"
			:components="components"
			:gridOptions="gridOptions"
			:style="!customConfig.tableOptions ? 'padding-top: 80px' : ''"
			class="ag-theme-material w-100 my-4 ag-grid-table"
			:class="[{'ag-customizer-container': !isWidthPortatil}]"
			:columnDefs="columnDefs"
			:defaultColDef="defaultColDef"
			:rowData="usersData"
			:rowSelection="customConfig.rowSelection"
			colResizeDefault="shift"
			:animateRows="true"
			:pagination="true"
			:paginationPageSize="20"
			:enableRtl="$vs.rtl"
			:overlayNoRowsTemplate="overlayNoRowsTemplate"
			:overlayLoadingTemplate="overlayLoadingTemplate"
			:tooltipShowDelay="tooltipShowDelay"
			:enableCellTextSelection="true"
			@grid-ready="onGridReady"
			@rowSelected="rowSelected"
		></ag-grid-vue>
	</div>
</template>

<script>
import {visitPoinListOptimization} from "../visit-point/model/VisitPointListOptimizationMixin";

export default {
	mixins: [visitPoinListOptimization],
};
</script>

<style lang="scss">
:root {
	--vs-dropdown-z-index: 10000;
}
#page-visit-point-list .vx-card .vx-card__header {
	padding: 0 !important;
}
#search-data .tags-input-wrapper-default {
	overflow-y: scroll;
	height: 60px;
	resize: none;
}
.ag-header-cell-label {
	font-size: 14px;
	font-weight: bold;
}
.ag-grid-table {
	color: inherit !important;
	height: calc(var(--vh, 1vh) * 100 - 10rem) !important;
}
</style>
